// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-title-wrapper {
  display: flex;
  padding-top: 10px;
}
.image-title-wrapper img {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-right: 16px;
  background: white;
}
.image-title-wrapper .title-wrapper {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 17px;
  padding-top: 5px;
  margin-left: 25%;
}

@media (max-width: 600px) {
  .image-title-wrapper {
    padding-top: 0px;
  }
  .image-title-wrapper .title-wrapper {
    margin-left: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/image-title/image-title.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;AAEE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAKA;EACE;IACE,gBAAA;EAFF;EAIE;IACE,eAAA;EAFJ;AACF","sourcesContent":[".image-title-wrapper {\n  display: flex;\n  padding-top: 10px;\n\n  img {\n    width: 32px;\n    height: 32px;\n    border: 1px solid rgb(255 255 255 / 20%);\n    border-radius: 50%;\n    margin-right: 16px;\n    background: white;\n  }\n\n  .title-wrapper {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: 17px;\n    padding-top: 5px;\n    margin-left: 25%;\n  }\n}\n\n\n@media (max-width: 600px) {\n  .image-title-wrapper {\n    padding-top: 0px;\n\n    .title-wrapper {\n      margin-left: 0%;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
